import { Box } from '@mui/material'
import React from 'react'

import CaseInfo from '../components/CaseInfo'
import { RIGHT_SIDEBAR_WIDTH } from '../utils/constants'

interface CaseInfoLayoutProps {
  children: React.ReactNode
  rightPanel?: React.ReactNode
  disabled?: boolean
  onSaveAsImage?: () => void
  onSaveAsPDF?: () => void
  handleSaveToProject?: () => void
}
const CaseInfoLayout: React.FC<CaseInfoLayoutProps> = ({
  rightPanel,
  children,
  disabled = false,
  onSaveAsImage,
  onSaveAsPDF,
  handleSaveToProject,
}) => {
  return (
    <Box display="flex" flexGrow={1}>
      <Box display="flex" flexGrow={1} flexDirection="column">
        <Box>
          <CaseInfo
            disabled={disabled}
            onSaveAsImage={onSaveAsImage}
            onSaveAsPDF={onSaveAsPDF}
            handleSaveToProject={handleSaveToProject}
          />
        </Box>
        <Box display="flex" flexGrow={1} px={0.5}>
          {children}
        </Box>
      </Box>
      {rightPanel && (
        <Box
          display="flex"
          flexGrow={1}
          flexDirection="column"
          width={`${RIGHT_SIDEBAR_WIDTH}px`}
        >
          {rightPanel}
        </Box>
      )}
    </Box>
  )
}

export default CaseInfoLayout
